module.exports = __webpack_public_path__ + "static/assets/e8356dcc166d4bee392a116997148bcb.png";